
import React from "react";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Building, Users } from "lucide-react";

interface BusinessDetailsProps {
  companySize: string;
  targetAudience: string;
  updateBusinessData: (key: string, value: string) => void;
}

const BusinessDetails: React.FC<BusinessDetailsProps> = ({
  companySize,
  targetAudience,
  updateBusinessData
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="space-y-2">
        <Label htmlFor="company-size" className="flex items-center gap-1">
          <Building className="h-4 w-4" />
          Company Size
        </Label>
        <Select 
          value={companySize} 
          onValueChange={(value) => updateBusinessData("companySize", value)}
        >
          <SelectTrigger id="company-size">
            <SelectValue placeholder="Select company size" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="1-10">1-10 employees</SelectItem>
            <SelectItem value="11-50">11-50 employees</SelectItem>
            <SelectItem value="51-200">51-200 employees</SelectItem>
            <SelectItem value="201-500">201-500 employees</SelectItem>
            <SelectItem value="501-1000">501-1000 employees</SelectItem>
            <SelectItem value="1000+">1000+ employees</SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="target-audience" className="flex items-center gap-1">
          <Users className="h-4 w-4" /> 
          Target Audience
        </Label>
        <Textarea
          id="target-audience"
          placeholder="Describe your ideal customers or target demographic"
          className="resize-none h-[80px]"
          value={targetAudience || ""}
          onChange={(e) => updateBusinessData("targetAudience", e.target.value)}
        />
      </div>
    </div>
  );
};

export default BusinessDetails;
